import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useNavigate, useParams } from 'react-router-dom';

import * as routes from '../../../constants/Routing';
import Text from '../../../react-components/Text';
import { AuthBody, AuthBodyFooter } from '../Auth.styled';
import { RecoveryRequest } from './RecoveryRequest';
import { RecoveryReset } from './RecoveryReset';

export const Recovery = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  return (
    <>
      <AuthBody container direction="column" justifyContent="center">
        <Grid item className="animate__animated animate__fadeIn">
          <Grid container justifyContent="center">
            <Text intlId="auth.recovery" variant="h5" />
          </Grid>

          <VSpacer large />

          <Grid container direction="column" justifyContent="center" style={{ minHeight: `250px` }}>
            {!token ? <RecoveryRequest /> : <RecoveryReset />}
          </Grid>
        </Grid>
      </AuthBody>

      <Grid item>
        <VSpacer small />
      </Grid>

      <AuthBodyFooter item container justifyContent="space-between">
        <Grid item>
          <Text
            isBold
            style={{
              fontSize: `12px`,
            }}
            variant="button"
            intlId="auth.login"
            onClick={() => navigate(routes.AUTH.LOGIN)}
          />
        </Grid>
      </AuthBodyFooter>
    </>
  );
};
